// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import type { LiveActivityPayload } from "@clipboardhealth/capacitor-live-activity/src/definitions";

import { type LiveActivityShift, type LiveActivityWorkplace } from "./types";

export interface CreateLiveActivityContentStatePayloadParams {
  workerId: string;
  shift: LiveActivityShift;
  workplace: LiveActivityWorkplace;
  clipboardScore: {
    clockInOnTime: number;
    latenessPenalty: number;
  };
}

/**
 * Converts LiveActivityData to the format expected by iOS native code
 * iOS expects specific types: strings for text fields, numbers for numeric fields
 */
export function createLiveActivityContentStatePayload(
  params: CreateLiveActivityContentStatePayloadParams
): LiveActivityPayload {
  const { shift, workplace, workerId, clipboardScore } = params;

  const shiftStart = new Date(shift.start);
  const shiftEnd = new Date(shift.end);

  return {
    schemaVersion: "1.0.0",
    view: "PRE_DEPARTURE_SHIFT_VIEW",
    worker: {
      id: workerId,
    },
    workplace: {
      name: workplace.name,
      address: {
        formattedAddress: workplace.address.formattedAddress,
        longitude: workplace.address.longitude,
        latitude: workplace.address.latitude,
      },
      timezone: workplace.timezone,
    },
    shift: {
      id: shift.id,
      start: shiftStart.toISOString(),
      end: shiftEnd.toISOString(),
    },
    clipboardScore: {
      clockInOnTime: clipboardScore.clockInOnTime,
      latenessPenalty: clipboardScore.latenessPenalty,
    },
    trip: {
      expectedArrivalTime: shift.targetArrivalTime ?? shift.start,
    },
  };
}
